export default "__VITE_ASSET__fb$pCraO__"